import { MakeDashboard } from 'main/factories/modules/Dashboard/dashboard';
import { MakePushNotification } from 'main/factories/modules/PushNotification/pushNotification';
import { useAuth } from 'presentation/app/hooks/useAuth';
import { AdministratorsList } from 'presentation/app/modules/Administrators/pages/administrators-list';
import { CreateOrUpdateAdministrator } from 'presentation/app/modules/Administrators/pages/create-or-update-administrator';
import { ApiKeys } from 'presentation/app/modules/ApiKeys/pages';
import { Course } from 'presentation/app/modules/Courses/pages';
// import { RegisterEntityForm } from 'presentation/app/modules/Entities/components/entity-settings/tabs-contents/register-entity-form';
import { Organization } from 'presentation/app/modules/Entities/pages';
import { CreateEntityForm } from 'presentation/app/modules/Entities/pages/create-entity-form';
import { EntityList } from 'presentation/app/modules/Entities/pages/entity-list';
import { EntitySettings } from 'presentation/app/modules/Entities/pages/entity-settings';
import { QuestionOptionsForm } from 'presentation/app/modules/EvaluationCriteria/components/question-options-form';
import { EvalutionCriteria } from 'presentation/app/modules/EvaluationCriteria/pages/evaluation-criteria';
import { EvaluationCriteriaForm } from 'presentation/app/modules/EvaluationCriteria/pages/evaluation-criteria-form';
import { ConfirmOrEditMarkerLocationOnMap } from 'presentation/app/modules/InternshipLocations/pages/confirm-or-edit-marker-location-on-map';
import { CreateOrUpdateInternshipLocation } from 'presentation/app/modules/InternshipLocations/pages/create-or-update-internship-location';
import { InternshipLocationsList } from 'presentation/app/modules/InternshipLocations/pages/internship-locations-list';
import { Partners } from 'presentation/app/modules/Partners/pages';
import { PersonDetails } from 'presentation/app/modules/Person/pages/person-details';
import { PersonList } from 'presentation/app/modules/Person/pages/person-list';
import { Profile } from 'presentation/app/modules/Profile/pages';
import { RadinosPage } from 'presentation/app/modules/Reports/pages/radinos';
import { SectorsList } from 'presentation/app/modules/Sectors/pages/sectors-list';
import { Task } from 'presentation/app/modules/Task/pages';
import { UsersOnline } from 'presentation/app/modules/UsersOnline/pages';
import { Navigate } from 'react-router-dom';

export const PrivateRoutes = (props: any) => {
  const { currentUser } = useAuth();
  if (!currentUser) {
    return <Navigate to={{ pathname: '/login' }} />;
  }

  return <>{props.children}</>;
};

const privateRoutes = [
  // Dashboard
  {
    path: '/dashboard',
    exact: true,
    component: <MakeDashboard />,
  },
  // Cursos - Courses
  {
    path: 'cadastros/cursos',
    exact: true,
    component: <Course />,
  },
  {
    path: 'cadastros/setores',
    exact: true,
    component: <SectorsList />,
  },
  {
    path: '/cadastros/tarefas',
    exact: true,
    component: <Task />,
  },
  // Parceiros - Partners
  {
    path: '/cadastros/parceiros',
    exact: true,
    component: <Partners />,
  },
  // Chaves de API - Api Keys
  {
    path: '/ferramentas/chaves-api',
    exact: true,
    component: <ApiKeys />,
  },
  // Usuários - Users
  {
    path: 'cadastros/usuarios',
    exact: true,
    component: <AdministratorsList />,
  },
  {
    path: 'cadastros/usuarios/editar/:id',
    exact: true,
    component: <CreateOrUpdateAdministrator />,
  },
  {
    path: 'cadastros/usuarios/novo',
    exact: true,
    component: <CreateOrUpdateAdministrator />,
  },
  // Locais de Estágio - Internship Locations
  {
    path: 'cadastros/locais-de-estagio',
    exact: true,
    component: <InternshipLocationsList />,
  },
  {
    path: 'cadastros/locais-de-estagio/editar/:id',
    exact: true,
    component: <CreateOrUpdateInternshipLocation />,
  },
  {
    path: 'cadastros/locais-de-estagio/novo',
    exact: true,
    component: <CreateOrUpdateInternshipLocation />,
  },
  {
    path: 'cadastros/locais-de-estagio/novo/confirmar-localizacao-do-marcador-no-mapa',
    exact: true,
    component: <ConfirmOrEditMarkerLocationOnMap />,
  },
  {
    path: 'cadastros/locais-de-estagio/editar/:id/editar-localizacao-do-marcador-no-mapa',
    exact: true,
    component: <ConfirmOrEditMarkerLocationOnMap />,
  },
  // Instrumentos de Avaliação - EvaluationCriteria
  {
    path: 'cadastros/instrumentos-de-avaliacao',
    exact: true,
    component: <EvalutionCriteria />,
  },
  {
    path: 'cadastros/instrumentos-de-avaliacao/editar/:id',
    exact: true,
    component: <EvaluationCriteriaForm />,
  },
  {
    path: 'cadastros/instrumentos-de-avaliacao/novo',
    exact: true,
    component: <EvaluationCriteriaForm />,
  },
  {
    path: 'cadastros/instrumentos-de-avaliacao/opcoes/:id',
    exact: true,
    component: <QuestionOptionsForm />,
  },
  // Organizações - Entities
  {
    path: 'organizacoes/configuracao/:id/:name',
    exact: true,
    component: <EntitySettings />,
  },
  {
    path: '/organizacoes',
    exact: true,
    component: <EntityList />,
  },

  {
    path: '/organizacoes/novo',
    exact: true,
    component: <CreateEntityForm />,
  },

  {
    path: '/organizacoes/editar/:id',
    exact: true,
    component: <CreateEntityForm />,
  },

  // Pessoas
  {
    path: '/pessoas',
    exact: true,
    component: <PersonList />,
  },

  {
    path: '/pessoas/:id',
    exact: true,
    component: <PersonDetails />,
  },
  // Users Online
  {
    path: '/usuarios-online',
    exact: true,
    component: <UsersOnline />,
  },
  {
    path: '/ferramentas/push-notification',
    exact: true,
    component: <MakePushNotification />,
  },
  /* 
  {
    path: '/ferramentas/notificacoes',
    exact: true,
    component: <MakeNotifications />,
  }, */

  {
    path: '/perfil',
    exact: true,
    component: <Profile />,
  },

  {
    path: '/organizacao/:entityId',
    exact: true,
    component: <Organization />,
  },

  {
    path: '/relatorios/radinos',
    exact: true,
    component: <RadinosPage />,
  },

  // Todas - All
  { path: '*', component: <Navigate to="/dashboard" /> },
];

export { privateRoutes };
